import {IUser} from '../../declarations/iUser';

export const getUserInfo = async (userId: string): Promise<IUser> => {
  return {
    userId
  };
};
